import { useMutation, useQueryClient } from "react-query";
import { useAccessToken } from "hooks/useAccessToken";
import { showMutationAlert } from "utils/helpers";
import useAlert from "hooks/useAlert";
import mutationFn from "../ApiLayer/Properties/setBuildingModelProperty";

export const useSetBuildingModelProperty = (buildingModelUids: string[]) => {
    const accessToken = useAccessToken();
    const queryClient = useQueryClient();
    const alert = useAlert();

    return useMutation({
        onSuccess: () => {
            queryClient.invalidateQueries({
                queryKey: ["properties"],
            });

            buildingModelUids.forEach((buildingModelUid) => {
                queryClient.invalidateQueries({
                    queryKey: ["buildingModelHeader", buildingModelUid],
                });
            });

            queryClient.invalidateQueries({
                queryKey: ["buildingModelsTable"],
            });

            alert.success("Property added to building(s)");
        },
        mutationFn: async (propertyName: string | null) => mutationFn(accessToken, buildingModelUids, propertyName),
        onError: (errors) => {
            showMutationAlert(errors, alert);
        },
    });
};
